import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx } from "vue"

import { ref } from "vue";
import QuoteCalculation from "./components/QuoteCalculation.vue";
import QuoteList from "./components/QuoteList.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isListType = ref(false);

const quoteCalculationElement = document.getElementById("quote-calculation");
if (quoteCalculationElement) {
  const dataType = quoteCalculationElement.getAttribute("data-type");
  if (dataType === "list" || window.abList) {
    isListType.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      (isListType.value)
        ? (_openBlock(), _createBlock(QuoteList, { key: 0 }))
        : (_openBlock(), _createBlock(QuoteCalculation, { key: 1 }))
    ]),
    _: 1
  }))
}
}

})